module.exports = __webpack_public_path__ + "static/img/manual-38.8c21e42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-38.png
// module id = Aieb
// module chunks = 4